export default [
    "56 56",
    '<path d="M18 28L25 35L39 21M51.8333 28C51.8333 40.8867 41.3866 51.3334 28.5 51.3334C15.6133 51.3334 5.16666 40.8867 5.16666 28C5.16666 15.1134 15.6133 4.66669 28.5 4.66669C41.3866 4.66669 51.8333 15.1134 51.8333 28Z" fill="none" stroke="var(--ci-primary-color, currentColor)"  stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>'
   ]